// extracted by mini-css-extract-plugin
export var errorIcon = "_k6-1";
export var nameLogo = "_k6-0";